export default __webpack_public_path__ + "static/blink-logo.f3f299eb.svg";